/**
 client location 관련 유틸리티
 @packageDocumentation
 */

/**
 * hash 변경 이벤트 핸들러 추가
 * @param listener
 */
export const onHashChanged = (listener: (this: Window, e: HashChangeEvent) => any) => {
  window.addEventListener('hashchange', listener)
}
